import { HeaderRequestId, postGenStat } from '@blk/aw-api-clients';
import moment from 'moment';
import { AWLogCreator, AWLogFunction, GenStatV2, LogPayload, LoggerOptions, NonFatalErrorPayload } from './Models';

/**
 * This almost works like createAction with Redux. Given a 'logCreator' it wraps it and gives you an easy function to
 * call to log a user action.  Creating new logs does not require changing this function, only adding the 'logCreators'
 * below.
 * @param {(partialGenStat: T) => Partial<GenStatV2>} logCreator
 * @param {() => LoggerOptions} getOptions
 * @returns {(partialGenStat?: T) => void}
 */

export function generateLogger<T extends Partial<GenStatV2>>(
  logCreator: AWLogCreator<T>,
  getOptions: () => LoggerOptions
): AWLogFunction<T> {
  return (partialGenStat?: T) => {
    const date = new Date();
    const asOfDate = moment().utc().valueOf();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    const headerRequestId = new HeaderRequestId();
    const payload: LogPayload = {
      ...logCreator(partialGenStat),
      ...getOptions(),
      asOfDate,
      endDate: asOfDate,
      date1: date.getTime(),
      [HeaderRequestId.NAME]: headerRequestId.getId(),
      url: window.location.href,
    };
    postGenStat(payload, headerRequestId).catch((e) => {
      console.warn(
        `The failed call to "stats/v2" is non-fatal. This call is for logging user actions, which is not required for the app to run or function properly.\nRequest ID: ${headerRequestId.getId()}\n`,
        e
      );
    });
  };
}

export const NON_FATAL_ERROR = 'NON_FATAL_ERROR';
export function logNonFatalError(
  error: Error | string,
  type: 'error' | 'warning' = 'warning',
  silent = type === 'warning'
) {
  document.dispatchEvent(
    new CustomEvent(NON_FATAL_ERROR, { detail: { error, type, silent } satisfies NonFatalErrorPayload })
  );
}
